const convertStringArrayToString = (
  arr: string[] | undefined,
): string | undefined => (arr?.length ? arr.join(",") : undefined);

export default convertStringArrayToString;
